import { TestimonialState } from '~/types/graphql';

export const TAB_KEYS: Record<string, string> = Object.freeze({
  verified: 'verified',
  actionNeeded: 'action_needed',
  pending: 'pending',
  archived: 'archived',
});

export const ARCHIVING_TESTIMONIAL_STATE = 'archiving';
export const testimonialStates = Object.freeze({
  REVIEW_TESTIMONIAL_STATES: [TestimonialState.Requested, TestimonialState.New],
  PENDING_TESTIMONIAL_STATES: [
    TestimonialState.Requested,
    TestimonialState.OnLinkedinVerification,
    TestimonialState.OnManualVerification,
  ],
  ACTION_NEEDED_TESTIMONIAL_STATES: [TestimonialState.Approving, TestimonialState.Failed, TestimonialState.Declined],
  FAILED_TESTIMONIAL_STATES: [TestimonialState.Failed, TestimonialState.Declined],
  VERIFIED_TESTIMONIAL_STATES: [ARCHIVING_TESTIMONIAL_STATE, TestimonialState.Verified],
  VISIBLE_TESTIMONIAL_STATES: [TestimonialState.Verified],
  ARCHIVED_TESTIMONIAL_STATES: [TestimonialState.Archived],
  APPROVED_TESTIMONIAL_STATES: [
    TestimonialState.OnManualVerification,
    TestimonialState.OnLinkedinVerification,
    TestimonialState.Verified,
  ],
});

export const PENDING_STATES_MAP: Record<string, string> = Object.freeze({
  [TestimonialState.Requested]: 'requested',
  [TestimonialState.OnManualVerification]: 'verifying',
  [TestimonialState.OnLinkedinVerification]: 'verifying',
} as const);
